/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getLoginFeatureFlags} from '../api'

 export const useQueryGetLoginFeatureFlags = createReactQueryHook('getLoginFeatureFlags', getLoginFeatureFlags)
